import React from 'react';

interface DashboardButtonProps {
    text: string;
    onClick?: () => void;
    className?: string;
}

const DashboardButton: React.FC<DashboardButtonProps> = ({text, onClick, className = ''}) => {
    return (
        <button
            className={`bg-mld-background text-mld-menu-text py-2 px-6 rounded-full inline-flex items-center font-medium transition-all duration-200 hover:bg-mld-gray-200 focus:outline-none focus:ring-2 focus:ring-mld-primary focus:ring-offset-2 min-h-[44px] cursor-pointer ${className}`}
            onClick={onClick}>
            <span>{text}</span>
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2" viewBox="0 0 20 20" fill="currentColor">
                <path
                    fillRule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                />
            </svg>
        </button>
    );
};

export default DashboardButton;
